<div class="main-container">
  <swiper
    #swiperHero
    [config]="sliders.length > 1 ? configDesktop : {}"
    *ngIf="sliders.length > 1 && !isMobile"
    class="swiper-app-desktop"
  >
    <ng-template swiperSlide *ngFor="let item of sliders">
      <ng-container
        *ngIf="
          item.videoLink && item.videoLink !== 'null';
          else checkVideoDesktop
        "
      >
        <div class="bg-video">
          <iframe
            [src]="transformVideoLink(item.videoLink) | safeUrl"
            frameborder="0"
            allow="autoplay; encrypted-media"
            sandbox="allow-scripts allow-same-origin"
            loading="lazy"
            alt="video promo"
            class="iframe"
          >
          </iframe>
        </div>
      </ng-container>
      <ng-template #checkVideoDesktop>
        <ng-container
          *ngIf="
            item.videoDesktop && item.videoDesktop !== 'null';
            else sliderContent
          "
        >
          <ng-container *ngIf="isGif(item.videoDesktop); else videoTagDesktop">
            <img
              [src]="item.videoDesktop"
              class="gif-option"
              alt="slider gif"
            />
          </ng-container>
          <ng-template #videoTagDesktop>
            <video
              autoplay
              muted
              loop
              [src]="item.videoDesktop"
              class="video-option"
            ></video>
          </ng-template>
        </ng-container>
      </ng-template>
      <ng-template #sliderContent>
        <app-slider [item]="item"></app-slider>
      </ng-template>
    </ng-template>
  </swiper>
  <swiper
    #swiperHero
    [config]="sliders.length === 1 ? config : {}"
    *ngIf="sliders.length === 1 && !isMobile"
    class="swiper-app-desktop"
  >
    <ng-template swiperSlide *ngFor="let item of sliders">
      <ng-container
        *ngIf="
          item.videoLink && item.videoLink !== 'null';
          else checkSingleVideoDesktop
        "
      >
        <div class="bg-video">
          <iframe
            [src]="transformVideoLink(item.videoLink) | safeUrl"
            frameborder="0"
            allow="autoplay; encrypted-media"
            sandbox="allow-scripts allow-same-origin"
            loading="lazy"
            alt="video promo"
            class="iframe"
          >
          </iframe>
        </div>
      </ng-container>
      <ng-template #checkSingleVideoDesktop>
        <ng-container
          *ngIf="
            item.videoDesktop && item.videoDesktop !== 'null';
            else singleSliderContent
          "
        >
          <ng-container
            *ngIf="isGif(item.videoDesktop); else videoTagDesktopSingle"
          >
            <img
              [src]="item.videoDesktop"
              class="gif-option"
              alt="slider gif"
            />
          </ng-container>
          <ng-template #videoTagDesktopSingle>
            <video
              autoplay
              muted
              loop
              [src]="item.videoDesktop"
              class="video-option"
            ></video>
          </ng-template>
        </ng-container>
      </ng-template>
      <ng-template #singleSliderContent>
        <app-slider [item]="item"></app-slider>
      </ng-template>
    </ng-template>
  </swiper>
  <div class="btn-container" *ngIf="!isMobile">
    <div
      *ngIf="sliders.length > 1"
      (click)="slideNext()"
      class="swiper-button-next"
    ></div>
    <div
      *ngIf="sliders.length > 1"
      (click)="slidePrev()"
      class="swiper-button-prev"
    ></div>
  </div>
  <swiper
    #swiperHeroMobile
    [config]="configMobile"
    *ngIf="sliders.length > 1 && isMobile"
    class="swiper-app-mobile"
  >
    <ng-template swiperSlide *ngFor="let item of sliders">
      <app-slider
        [item]="item"
      ></app-slider>
    </ng-template>
  </swiper>
  <swiper
    #swiperHeroMobile
    [config]="sliders.length === 1 ? config : {}"
    *ngIf="sliders.length === 1 && isMobile"
    class="swiper-app-mobile"
  >
    <ng-template swiperSlide *ngFor="let item of sliders">
      <app-slider
        [item]="item"
      ></app-slider>
    </ng-template>
  </swiper>
  <div class="btn-container" *ngIf="isMobile">
    <div
      *ngIf="sliders.length > 1"
      (click)="slideNextMobile()"
      class="swiper-button-next"
    ></div>
    <div
      *ngIf="sliders.length > 1"
      (click)="slidePrevMobile()"
      class="swiper-button-prev"
    ></div>
  </div>

  <div class="store-download">
    <div class="store-text">
      <p>Descargá la app y Sumate a Shell Box</p>
    </div>
    <div class="store-icons">
      <a
        href="https://play.google.com/store/apps/details?id=com.raizen.acelera&pli=1"
        target="_blank"
      >
        <img
          [src]="isMobile ? mobileGooglePlay : desktopGooglePlay"
          alt="play store"
        />
      </a>
      <a
        href="https://apps.apple.com/ar/app/shell-box-pague-e-ganhe/id1037433060"
        target="_blank"
      >
        <img
          [src]="isMobile ? mobileAppStore : desktopAppStore"
          alt="app store"
        />
      </a>
    </div>
  </div>
  <div *ngIf="!isMobile" class="phones-container">
    <div class="phone-card" *ngFor="let image of desktopImages; let i = index">
      <p class="phone-card-title">{{ image.title }}</p>
      <img [src]="image.src" alt="phone" class="phone-image-fade-in" [ngStyle]="{ 'width': i !== 1 && 'auto'}" />
      <div class="phone-card-text">
        <p>{{ image.description }}</p>
      </div>
    </div>
  </div>
  <swiper
    *ngIf="isMobile"
    [config]="configPhone"
    class="swiper-phone"
    (swiper)="onSwiper($event)"
    (slideChange)="setSlide($event)"
  >
    <ng-container *ngFor="let image of mobileImages; let i = index">
      <ng-template swiperSlide class="phone-card">
        <div class="phone-card">
          <span class="phone-card-title">{{ image.title }}</span>
          <img [src]="image.src" alt="phone" />
          <p>{{ image.text }}</p>
        </div>
      </ng-template>
    </ng-container>
  </swiper>
  <div class="discount-container">
    <div class="use-discount">
      <div class="video-container">
        <video #videoPlayer1 class="custom-video" 
          (play)="isPlayingFirst = true" 
          (pause)="isPlayingFirst = false"
          >
          <source src="../../../assets/video/Como_usar_tus_descuentos.mp4" type="video/mp4">
          Tu navegador no soporta el tag de video.
        </video>
        <button class="play-btn" (click)="toggleVideo(videoPlayer1, 1)">
          <ng-container *ngIf="!isPlayingFirst">
            <img src="../../../assets/images/playVideo.svg" alt="Reproducir video">
          </ng-container>
          <ng-container *ngIf="isPlayingFirst">
            <img src="../../../assets/images/pauseVideo.svg" alt="Pausar video">
          </ng-container>
        </button>
      </div>           
      <div class="learn-discount">
        <h3>Cómo usar tus descuentos</h3>
        <p>
          Para utilizar los descuentos de Shell Box deberás seguir los siguientes pasos:
        </p>
          <div class="benefits-points" *ngFor="let benefit of discounts; let last = last">
            <span>{{ benefit.numero }}. </span>
            <p> {{ benefit.descripcion }}</p>
          </div>
        <button (click)="downloadApp()">Descargar la App</button>
      </div>
    </div>
  </div>
  <div class="discount-container second-video">
    <div class="use-discount">
      <div class="learn-discount">
        <h3>Cómo usar tus puntos Shell Box</h3>
        <p>Para utilizar tus puntos Shell Box deberás seguir los siguientes pasos:</p>
        <div class="benefits-points" *ngFor="let benefit of  points; let last = last">
          <span>{{ benefit.numero }}. </span>
          <p> {{ benefit.descripcion }}</p>
        </div>
        <button (click)="downloadApp()">Descargar la App</button>
      </div>
      <div class="video-container">
        <video #videoPlayer2 class="custom-video" 
          (play)="isPlayingSecond = true" 
          (pause)="isPlayingSecond = false" >
          <source src="../../../assets/video/Como_usar_tus_puntos.mp4" type="video/mp4">
          Tu navegador no soporta el tag de video.
        </video>
        <button class="play-btn" (click)="toggleVideo(videoPlayer2, 2)">
          <ng-container *ngIf="!isPlayingSecond">
            <img src="../../../assets/images/playVideo.svg"  alt="Reproducir video">
          </ng-container>
          <ng-container *ngIf="isPlayingSecond">
            <img src="../../../assets/images/pauseVideo.svg" alt="Pausar video">
          </ng-container>
        </button>
      </div>      
    </div>
  </div>
  
  <div class="map-container">
    <div class="branches-container">
      <p>Encontrá las estaciones adheridas con Shell Box</p>
      <div class="branches-list">
        <div *ngFor="let branch of branches" class="branch-item">
          <app-branches [branch]="branch"></app-branches>
        </div>
      </div>
    </div>
    <div class="map-area desktop">
      <div #mapContainer id="map"></div>
    </div>
    <div class="map-area mobile">
      <div #mapContainerMobile id="map"></div>
    </div>
  </div>
</div>
